// Spells that add to a caster's hits, whatever their class.
const ATTACK_ROLL_KINDS = new Set(['weapon', 'unarmed', 'spell']);
const FEATURE_ID = 'spell:conjure-minor-elementals';

/** Conjure Minor Elementals: 2d8 of the chosen type on a hit within 15 feet, plus 2d8 per slot level above 4. Silent otherwise. */
export const evaluateConjureMinorElementals = ({ context, queries = {} }) => {
  const effect = (queries.activeEffects || []).find(item => item?.definitionId === FEATURE_ID && String(item.targetCombatantId) === String(context?.attacker?.combatantId));
  if (!effect || !ATTACK_ROLL_KINDS.has(context?.attack?.kind) || Number(queries.targetDistanceFeet) > 15) return [];
  return {
    status: 'automatic', featureId: FEATURE_ID, featureLabel: 'Conjure Minor Elementals', reasonCode: 'spirits-active',
    components: [{ id: FEATURE_ID, label: 'Conjure Minor Elementals', source: { type: 'spell', featureId: FEATURE_ID }, dice: { count: 2 * (1 + Math.max(0, Number(effect.castLevel) - 4)), sides: 8 }, flat: 0,
      damageType: { mode: 'explicit', value: effect.choice?.damageType || 'cold' }, critical: { dice: 'double' } }],
    claims: [],
  };
};

/** True Strike's extra Radiant dice, on the attack it buys. */
export const evaluateTrueStrike = ({ context, queries = {} }) => {
  const effect = (queries.activeEffects || []).find(item => item?.definitionId === 'spell:true-strike' && String(item.targetCombatantId) === String(context?.attacker?.combatantId));
  if (!effect?.extraDice || context?.attack?.kind !== 'weapon') return [];
  return { status: 'automatic', featureId: 'spell:true-strike', featureLabel: 'True Strike', reasonCode: 'cantrip-upgrade',
    components: [{ id: 'spell:true-strike', label: 'True Strike', source: { type: 'spell', featureId: 'spell:true-strike' }, dice: { count: effect.extraDice, sides: 6 }, flat: 0, damageType: { mode: 'explicit', value: 'radiant' }, critical: { dice: 'double' } }], claims: [] };
};
